import { useEffect, useState } from 'react'
import { SDrawerOrModal, SListTabs, STitle } from 'shj-components'
import { getAuditRecord, queryReviewApproval, getDetailByProcInstId } from '@/services/order'
import { Spin, Empty, Input } from 'antd';
import dayjs from 'dayjs';
import FlowTimeline from '@/components/FlowTimeline'
import styles from './index.module.less'

interface IProps {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  quoteBudgetId: string
}

const processStatusType = {
  complete: '#70a310',
  reject: 'red',
  terminate: 'gray',
  waitAudit: '#0064ff',
}

const { TextArea } = Input;

export default function ProcessRecord(prpos: IProps) {
  const { open, title, setOpen, quoteBudgetId = '' } = prpos

  const fileUrl = localStorage.getItem('SHJ_FILE_URL_PREFIX')
  const baseUrl = fileUrl && JSON.parse(fileUrl)

  const [chooseTab, setChooseTab] = useState<any>('')
  const [processTabList, setProcessTabList] = useState<Array<any>>([])
  const [processInfoMap, setProcessInfoMap] = useState<any>({})
  const [showInfoTab, setShowInfoTab] = useState('remark')
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [remarkList, setRemarkList] = useState<Array<any>>([])
  const [flowData, setFlowData] = useState<any>(null) // 商品详情信息

  useEffect(() => {
    initTab();
  }, [])

  const initTab = async () => {
    try {
      setModalLoading(true)
      const res = await getAuditRecord({
        params: {
          quoteBudgetId,
        }
      })
      if (Array.isArray(res) && res.length) {
        const infoMap = {}
        const list = res.map((item, index) => {
          infoMap[item?.id] = item;
          return {
            label: `图审${res?.length - index}`,
            key: item?.id,
            processInstanceId: item?.processInstanceId
          }
        })
        setChooseTab(list?.[0]?.key)
        setProcessInfoMap(infoMap);
        setProcessTabList(list);

        await initRemarkInfo(list?.[0]?.key)
        await initRecordInfo(list?.[0]?.processInstanceId)
      }
      setModalLoading(false)
    } catch (err) {
      setModalLoading(false)
      console.log(err)
    }
  }

  const initRemarkInfo = async (id: string) => {
    try {
      setLoading(true)
      const remarkInfoRes = await queryReviewApproval({
        params: {
          quotationFlowId: id,
        }
      })
      if (remarkInfoRes?.reviewApprovalList?.length) {
        const hasRemarkList = remarkInfoRes?.reviewApprovalList?.filter(item => item.remarks);
        const noSpaceList = ['报价费用', '整装图纸', '增项', '减项', '升降级', '优惠活动'];
        const renderRemarkList: any = [];
        hasRemarkList?.forEach(info => {
          if (noSpaceList?.includes(info?.pathName)) {
            renderRemarkList?.push({
              pathName: info?.pathName,
              remarks: info?.remarks,
            })
          } else {
            const index = renderRemarkList.findIndex(item => item.pathName === '选材')
            if (index === -1) {
              renderRemarkList?.push({
                pathName: '选材',
                spaceList: [{
                  pathName: info?.pathName?.split('>')?.[info?.pathName?.split('>')?.length - 1],
                  remarks: info?.remarks,
                }]
              })
            } else {
              renderRemarkList?.[index]?.spaceList?.push({
                pathName: info?.pathName?.split('>')?.[info?.pathName?.split('>')?.length - 1],
                remarks: info?.remarks,
              })
            }
          }
        })
        setRemarkList([...renderRemarkList]);
      }
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }

  const initRecordInfo = async (procInstId: stirng) => {
    try {
      const res: any = await getDetailByProcInstId({
        params: {
          procInstId,
        }
      })
      if (res?.variables?.entity) {
        setFlowData(res)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const onCancel = () => {
    setOpen(false)
  }

  const handleChangeTab = (tab) => {
    const tabInfo = processTabList?.filter((tabItem) => tabItem.key === tab);
    setChooseTab(tab)
    setShowInfoTab('remark')
    initRemarkInfo(tab)
    initRecordInfo(tabInfo?.[0]?.processInstanceId)
  }

  const handleChangeInfoTab = (tab) => {
    setShowInfoTab(tab)
  }

  return (
    <SDrawerOrModal
      title={title}
      mode="drawer"
      open={open}
      width={800}
      onCancel={onCancel}
      loading={modalLoading}
      antdProps={{
        footer: null,
        maskClosable: false,
      }}
    >
      { (modalLoading || processTabList?.length) ? <div className={styles.processRecordBox}>
        <SListTabs
          activeKey={chooseTab}
          items={processTabList}
          hideExtra={false}
          onChange={handleChangeTab} auth={undefined}
        />
        {chooseTab ? <div style={{ padding: '15px 0px 0px' }}>
          <STitle title={'基本信息'} />
          <div style={{ display: 'flex', marginTop: '15px' }}>
            <div style={{ display: 'flex', marginLeft: '10px' }}>
              <div>审核状态：</div>
              <div
                style={{
                  color: processStatusType?.[processInfoMap?.[chooseTab]?.processState] || '#000',
                  display: 'flex',
                  alignItems: 'center',
                  marginRight: '40px'
                }}>
                <div
                  style={{
                    width: '8px',
                    height: '8px',
                    backgroundColor: processStatusType?.[processInfoMap?.[chooseTab]?.processState] || '#000',
                    borderRadius: '50%',
                    marginRight: '4px'
                  }}></div>
                { processInfoMap?.[chooseTab]?.processStateName }
              </div>
            </div>
            <div style={{ display: 'flex'}}>
              <div>审核完成时间：</div>
              <div>{ dayjs(processInfoMap?.[chooseTab]?.lastUpdatedTime)?.format('YYYY-MM-DD HH:mm:ss') }</div>
            </div>
          </div>
          <div style={{ marginTop: '15px', marginLeft: '10px' }}>
            <SListTabs
              activeKey={showInfoTab}
              type="card"
              items={[{
                label: '审核批复',
                key: 'remark',
              }, {
                label: '审核日志',
                key: 'record',
              }]}
              hideExtra={false}
              onChange={handleChangeInfoTab}
              auth={undefined}
            />
            <Spin spinning={loading}>
              <div style={{ width: '100%'}}>
                {
                  showInfoTab === 'remark' ? (
                    <div style={{ marginTop: '5px', position: 'relative', minHeight: '200px' }}>
                      {
                        remarkList?.length ? remarkList?.map(item => (<div>
                          <div style={{ marginTop: '10px', fontSize: '18px', color: 'red', fontWeight: 'bold' }}>{item?.pathName}</div>
                          {
                            item?.pathName !== '选材' ? <TextArea style={{ marginTop: '10px' }} value={item?.remarks}></TextArea> : <div>
                              {
                                item?.spaceList?.map(space => (<div>
                                  <div style={{ marginTop: '10px', fontSize: '16px', color: 'red' }}>{space?.pathName}</div>
                                  <TextArea style={{ marginTop: '10px' }} value={space?.remarks}></TextArea>
                                </div>))
                              }
                            </div>
                          }
                        </div>)) : <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          style={{
                            position: 'absolute',
                            top: '70%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                          }}
                        />
                      }
                    </div>
                  ) : null
                }
                {
                  showInfoTab === 'record' ? (
                    <div style={{ marginTop: '25px' }}>
                      <FlowTimeline
                        isEnd={flowData?.isEnd}
                        fileUrl={baseUrl?.substring(0, baseUrl?.length - 1)}
                        auditList={flowData?.auditList || []}
                      />
                    </div>
                  ) : null
                }
              </div>
            </Spin>
          </div>
        </div> : null}
      </div> : <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      />}
    </SDrawerOrModal>
  )
}
